import { Injectable } from '@angular/core';
import { Base2Service } from '../base2.service';
import { Observable, from } from 'rxjs';
import { map } from 'rxjs/operators';
import { BaseclientService } from '../../apiclient/baseclient.service';

@Injectable({
  providedIn: 'root'
})
export class FidelityService {

  constructor(
    private base2: Base2Service,
    private baseClient: BaseclientService
  ) { }

  getHistory(idClient: number, userKey: string): Observable<any> {
    return from(this.base2.getBase("clients/fidelity/" + idClient, null, userKey))
      .pipe(
        map(data => data.list)
      )
  }


  getOffers(idClient: number, userKey: string): Observable<any> {
    const params = {
      id_client: idClient,
      filter: 0
    };
    return from(this.base2.getBase("fidelity_history", params, userKey))
      .pipe(
        map(data => data.list)
      )
  }

  getFidelityProducts(userKey: string, points: number, available: boolean): Promise<any> {

    const paramsDown = {
      down_fidelity_points: points,
    }

    const paramsUp = {
      up_fidelity_points: points,
    }

    return new Promise(resolve => {
      this.base2.getBase("products", available ? paramsDown : paramsUp, userKey).then(data => {
        resolve(data.list);
      });
    });
  }


  $_getHistory(idClient: number,id_merchant:any): Observable<any> {

    const params={
      "id_merchant":id_merchant,
      "id_client":idClient
    }
    return from(this.baseClient.postBaseApi("fidelity/clients",params))
      .pipe(
        map(data => data.list)
      )
  }


  $_getOffers(idClient: number, id_merchant:any): Observable<any> {

    const params = {
      "id_merchant":id_merchant,
      id_client: idClient,
      filter: 0
    };
    return from(this.baseClient.postBaseApi("fidelity/history", params))
      .pipe(
        map(data => data.list)
      )
  }

  $_getFidelityProducts(id_merchant: any, points: number, available: boolean): Promise<any> {

    const paramsDown = {
      id_merchant:id_merchant,
      down_fidelity_points: points,
    }

    const paramsUp = {
      id_merchant:id_merchant,
      up_fidelity_points: points,
    }

    return new Promise(resolve => {
   this.baseClient.postBaseApi("fidelity/products", available ? paramsDown : paramsUp).then(data => {
        resolve(data.list);
      });
    });
  }

}
